import {DataFetcher} from '@aboutyou/data-fetcher';
import {Gallery} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/gallery.types';
import {ProductImageTypes} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_images.types';
import {ImagesSection_Image} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useRouteEntities} from '@aboutyou/router';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React, {memo} from 'react';
import {isProductTileEntities} from '../../../features/ProductTile/isProductTileEntities';
import {ProductTileEntities} from '../../../features/ProductTile/types';
import {
  getProtoProductImageType,
  useProductImageTypeCallback,
} from '../../../shared-deprecated/useProductImageType';
import {useImagesSection} from '../useGetProductBulkSection';
import {ProductSliderProps, ProductSliderView} from './ProductSliderView';

const ProductSliderViewMemo = memo(ProductSliderView);

export const ProductSlider: React.FC<ProductSliderProps> = props => {
  const entities =
    useRouteEntities<ProductTileEntities>() as ProductTileEntities;
  const productImageTypeCallback = useProductImageTypeCallback();

  return (
    <DataFetcher
      request={useImagesSection()}
      Error={null}
      Loading={Skeleton}
      View={ProductSliderViewMemo}
      viewProps={props}
      computeDefaultState={() => {
        if (isProductTileEntities(entities)) {
          const {
            badges,
            brand,
            product,
            primaryBustImageGallery,
            primaryModelImageGallery,
            preferredProductImageType,
            gallery,
            gridColumns,
          } = entities;

          const images: ImagesSection_Image[] = (() => {
            const imageType =
              preferredProductImageType ??
              getProtoProductImageType(productImageTypeCallback());

            const imageGallery =
              imageType === ProductImageTypes.MODEL
                ? primaryModelImageGallery
                : primaryBustImageGallery;

            return imageGallery.map(image => ({image}));
          })();

          return {
            badges,
            qualitativeBadges: [],
            brand,
            images,
            isDefaultState: true,
            product,
            gallery: gallery?.elements?.length
              ? gallery
              : ({
                  elements: images.map(image => ({
                    type: {
                      $case: 'image',
                      image,
                    },
                  })),
                } as Gallery),
            gridColumns,
          };
        }

        return undefined;
      }}
    />
  );
};

const Skeleton = () => {
  return (
    <SkeletonBlock
      disableSpaceBelow
      $height={`${(100 / 3) * 4}vw` as `${number}vw`}
    />
  );
};
